import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays product metadata (materials and specifications).
 * Updates automatically when variants change, with fallback to product-level metafields.
 */
class ProductMetadata extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateMetadata);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateMetadata);
  }

  /**
   * Updates the metadata display when variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateMetadata = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newMetadata = event.detail.data.html.querySelector('product-metadata');

    if (!newMetadata) {
      // No metadata for this variant - hide the current block
      this.style.display = 'none';
      return;
    }

    // Show the block if it was hidden
    this.style.display = 'block';

    // Update the content
    morph(this, newMetadata, { childrenOnly: true });
  };
}

customElements.define('product-metadata', ProductMetadata);
